import mixin_work from '../../mixins/mixin_work'

export default {
  mixins: [mixin_work],
  props: ['work'],
  data() {
    return {
      is_subdomain: $('#app-wrapper').attr('is_subdomain'),
    }
  },
  computed: {
    userId: {
      get() {
        return this.$store.getters.userId
      }
    },
    title_buy: {
      get() {
        if ( this.work.status.sale_status=='sale' ) return this.$t('message.BuyOriginal');
        else return this.$t('message.BuyReproduction');
      }
    },
  },
  methods : {
    work_repr(field){
      if ( this.work==null ) return '';
      if ( this.work['status_repr']==null ) return '';
      if ( this.work['status_repr'][field]==null ) return '';
      return this.work['status_repr'][field];
    },

    work_digital(field){
      if ( this.work==null ) return '';
      if ( this.work['status_digital']==null ) return '';
      if ( this.work['status_digital'][field]==null ) return '';
      return this.work['status_digital'][field];
    },

    buy_work(event, order_type){
      if (event) event.preventDefault();

      if ( order_type==null ){
        if ( this.work.status.sale_status=='sale' ) order_type='original';
        else if ( this.work.status_repr!=null && this.work.status_repr.sale_status=='sale' ) order_type='reproduction';
        else if ( this.work.status_digital!=null && this.work.status_digital.sale_status=='sale' ) order_type='digital';
      }

      if ( this.userId>0 ) {
        action_deal.do_buy(event.target, this.work.work_id, '', this.$t("message.ErrorBuy"), '1', '', '', '', order_type);
      }
      else {
        if ( order_type=='digital' ) window.action_user.show_popup_login(null);
        else window.location.href='/checkout/'+this.work.work_id+'/'+order_type;
      }
    },
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/WorksItemCostMix.js
// module id = null
// module chunks = 